import { Trans, useTranslate } from "@similarweb/i18n-provider";
import { Button, Modal } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

const modalStyles: ReactModal.Styles = {
    content: {
        boxSizing: "border-box",
        width: "400px",
        padding: 0,
    },
};

interface IDeleteKeywordListConfirmationModalProps {
    isOpen: boolean;
    listName: string;
    isLoading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
    dataAutomationPrefix: string;
}

export const DeleteKeywordListConfirmationModal = ({
    isOpen,
    listName,
    isLoading = false,
    onCancel,
    onConfirm,
    dataAutomationPrefix,
}: IDeleteKeywordListConfirmationModalProps) => {
    const { translate } = useTranslate();

    return (
        <Modal
            isOpen={isOpen}
            customStyles={modalStyles}
            shouldCloseOnOverlayClick={!isLoading}
            onRequestClose={onCancel}
            data-automation={`${dataAutomationPrefix}-modal`}
        >
            <Modal.Header>
                <Modal.Title>
                    <Text fontVariant="h5">
                        <Trans i18nKey="demand_analysis.keyword_list_delete_confirmation.title" />
                    </Text>
                </Modal.Title>
            </Modal.Header>
            <Modal.Content>
                <Text fontVariant="body1">
                    <Trans
                        i18nKey="demand_analysis.keyword_list_delete_confirmation.content"
                        values={{ listName }}
                        components={{ b: <b /> }}
                    />
                </Text>
            </Modal.Content>
            <Modal.Footer>
                <Flex
                    width="100%"
                    justifyContent="flex-end"
                    gap="4px"
                >
                    <Button
                        dataAutomation={`${dataAutomationPrefix}-cancel-button`}
                        type="flatDark"
                        onClick={onCancel}
                        isDisabled={isLoading}
                    >
                        {translate("asset.sharing.footer.cancel")}
                    </Button>
                    <Button
                        dataAutomation={`${dataAutomationPrefix}-confirm-button`}
                        type="warning"
                        onClick={onConfirm}
                        isLoading={isLoading}
                        isDisabled={isLoading}
                    >
                        {translate("common.delete")}
                    </Button>
                </Flex>
            </Modal.Footer>
        </Modal>
    );
};
